<div class="thank-you-container">
  <div class="thank-you-content">
    <div class="thank-you-icon flex justify-content-center">
       <app-lottie-animation 
         [animationPath]="'assets/animation/animation-optimized.json'"
         [width]="'150px'" 
         [height]="'150px'"
         [loop]="false">
       </app-lottie-animation>
    </div>

    <h1 class="thank-you-title">You are In!</h1>

    <p class="thank-you-message">
      Thanks for signing up. You have just taken the first step toward planning your higher education journey the smart way.Check your inbox for your personalized roadmap and next steps.
    </p>

    <div class="cta-container">
      <button class="explore-dashboard-btn" (click)="navigateToDashboard()">
        Explore Dashboard
      </button>
    </div>
  </div>
</div>
